import { render, staticRenderFns } from "./AddNewBoard.vue?vue&type=template&id=02a01ac4&scoped=true"
import script from "./AddNewBoard.ts?vue&type=script&lang=ts&external"
export * from "./AddNewBoard.ts?vue&type=script&lang=ts&external"
import style0 from "./AddNewBoard.scss?vue&type=style&index=0&id=02a01ac4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a01ac4",
  null
  
)

export default component.exports